import React from 'react';
import { LOGO, APP } from '../config/appConfig';
import ConnectButton from '../components/wallet/ConnectButton';

export default function ConnectPrompt() {
  return (
    <div className="page center" style={{ minHeight: 'calc(100vh - 140px)', textAlign: 'center', flexDirection: 'column' }}>
      <div className="splash-logo-wrap" style={{ width: 140, height: 140, marginBottom: 18 }}>
        <div className="splash-ring">
          <svg viewBox="0 0 120 120">
            <defs>
              <linearGradient id="cpGrad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#10b981" />
                <stop offset="100%" stopColor="#06b6d4" />
              </linearGradient>
            </defs>
            <circle cx="60" cy="60" r="52" fill="none" stroke="url(#cpGrad)" strokeWidth="4" strokeLinecap="round" strokeDasharray="320" style={{ animation: 'ringSpin 2.5s ease-in-out infinite' }} />
          </svg>
        </div>
        <img src={LOGO} alt="" className="splash-logo" />
      </div>
      <div className="splash-title" style={{ fontSize: 30, marginBottom: 6 }}>{APP.name}</div>
      <div className="text-dim mb-16" style={{ fontSize: 13, letterSpacing: '.14em', textTransform: 'uppercase' }}>{APP.tagline}</div>
      <div className="text-dim mb-24" style={{ maxWidth: 320 }}>
        Connect your wallet to invest, earn daily rewards and grow your NFT collection.
      </div>
      <div style={{ width: '100%', maxWidth: 320 }}>
        <ConnectButton block size="lg" />
      </div>
    </div>
  );
}
